(function ($) {
    $(document).ready(function () {

        // how to use
        //   0 Add only section name to remove the view divs
        //   0 Please do not use "." in front of the classname while adding in a function
        //   0 Add Your section name in "getClass" function
        //   0 It will add a class on the section itself with the name of (section-name-view)

        $(".fellows-team-slider.column_image_slider.extra-div .fellow-card-wrapper .fellow-card").parent().addClass("div-to-remove")

        getClass("featured-carousel");
        getClass("fellows-team-slider.column_image_slider.extra-div");
        function getClass(sectionclass) {
            $("." + sectionclass).addClass(sectionclass + "-view");
            var className = $("." + sectionclass + " .views-element-container > div").attr('class');
            removeDIV("." + className);
            removeDIV("." + sectionclass + " .views-element-container");
            removeDIV("." + sectionclass + " .div-to-remove");
        }
        function removeDIV(DivClass) {
            var cnt = $(DivClass).contents();
            $(DivClass).replaceWith(cnt);
        }
    });
})(jQuery);